import React, { useState } from 'react';
import { ArrowLeft, Eye, EyeOff, LockKeyhole, Mail } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const inputClass = 'box-border w-full   rounded-lg border-0 bg-[#06110c] py-3 pl-10 pr-4 text-sm font-medium text-white outline-none ring-1 ring-inset ring-white/10 transition placeholder:text-white/25 hover:ring-white/20 focus:ring-2 focus:ring-[#20c77a]';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState('');
  const { login, authError } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');
    setSubmitting(true);
    const user = await login(form.email, form.password);
    setSubmitting(false);

    if (user) {
      if (user.role !== 'admin') {
        setLocalError('This login is for administrators only.');
        return;
      }
      navigate('/admin/dashboard');
    }
  };

  const errorMsg = localError || authError;

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#020906] px-4 py-8 font-dm text-white sm:px-6 sm:py-10">
      <title>GIGGS Admin Login</title>
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_50%_-10%,rgba(25,177,105,0.14),transparent_34%),linear-gradient(rgba(255,255,255,0.018)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.018)_1px,transparent_1px)] bg-[size:auto,22px_22px,22px_22px]" />
      <section className="relative z-10 w-full max-w-[470px] rounded-2xl border border-[#1c4b36]/70 bg-[#04100b]/95 p-5 shadow-[0_25px_90px_rgba(0,0,0,0.38)] backdrop-blur-sm sm:p-7 lg:p-8">
        <div className="flex items-center justify-between gap-4">
          <Link to="/" className="inline-flex items-center gap-2 text-xs font-semibold text-white/40 no-underline transition hover:text-[#46dc96] sm:text-sm"><ArrowLeft size={16} /> Home</Link>
          <img src="/images/logo-white.png" alt="GIGGS" className="h-8 w-auto" />
        </div>

        <div className="mt-8 text-center">
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#42d993]">Administrator</span>
          <h1 className="mb-0 mt-2 font-nunito text-2xl font-bold text-white sm:text-3xl">Admin sign in</h1>
          <p className="mb-0 mt-2 text-sm text-white/35">Access your Giggs administration dashboard.</p>
        </div>

        {errorMsg && <div className="mt-5 rounded-lg border border-red-400/20 bg-red-500/10 px-4 py-3 text-center text-sm font-medium text-red-200">{errorMsg}</div>}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <label className="block"><span className="mb-1.5 block text-[11px] font-semibold text-white/65">Email address</span><div className="relative"><Mail size={17} className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-white/25" /><input className={inputClass} type="email" name="email" placeholder="admin@giggs.com.au" value={form.email} onChange={handleChange} required /></div></label>
          <label className="block"><span className="mb-1.5 block text-[11px] font-semibold text-white/65">Password</span><div className="relative"><LockKeyhole size={17} className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-white/25" /><input className={`${inputClass} pr-11`} type={showPassword ? 'text' : 'password'} name="password" placeholder="Enter password" value={form.password} onChange={handleChange} required /><button type="button" className="absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-md border-0 bg-transparent text-white/25 transition hover:bg-white/[0.05] hover:text-white/70" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? <EyeOff size={17} /> : <Eye size={17} />}</button></div></label>
          <button type="submit" className="inline-flex min-h-11 w-full items-center justify-center rounded-lg border border-[#20c77a] bg-[#12ad68] px-5 text-sm font-bold text-[#02140b] shadow-[0_10px_30px_rgba(18,173,104,0.16)] transition hover:-translate-y-0.5 hover:bg-[#25d080] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0" disabled={submitting}>{submitting ? 'Signing in…' : 'Sign in'}</button>
        </form>
      </section>
    </main>
  );
};

export default AdminLogin;
